import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { formatDateRange } from "@madmedical/utils";
import { forHumans } from "@madmedical/medical";
import { FlatList } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../providers/routing";
import ReactTable from "../molecules/ReactTable";
import Tag from "../atoms/Tag";
import StatusBadge from "../atoms/StatusBadge";
import AvatarTexts from "../molecules/AvatarTexts";
import EvaluationStatuses from "../atoms/EvaluationStatuses";
import { useEvaluations } from "../providers/evaluation";
import useResponsive from "../util/useResponsive";
import EvaluationListItem from "../molecules/ListItem/EvaluationListItem";
const HealthEvaluationTable = ({ onEndReached }) => {
    const { evaluations, onSortChange } = useEvaluations();
    const navigate = useRouteNavigate();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("measures:type"),
            accessor: "metricType",
            width: "auto",
            Cell: ({ value: metricType }) => (_jsx(Tag, { children: t(`measures:${forHumans(metricType)}`) })),
            disableSortBy: true,
        },
        {
            Header: t("measures:measuredPeriod"),
            accessor: "dateRange",
            width: "20%",
            Cell: ({ value: dateRange }) => (_jsx(_Fragment, { children: formatDateRange(dateRange) })),
            defaultCanSort: !!onSortChange,
            disableSortBy: !onSortChange,
        },
        {
            Header: t("measures:alert"),
            accessor: "alertLevel",
            width: "20%",
            Cell: ({ value: alertLevel }) => alertLevel ? _jsx(StatusBadge, { level: alertLevel }) : null,
            defaultCanSort: !!onSortChange,
            disableSortBy: !onSortChange,
        },
        {
            Header: t("evaluatingDoctor"),
            accessor: "doctor",
            width: "20%",
            Cell: ({ value: doctor }) => (_jsx(AvatarTexts, { source: doctor.avatarUrl, label: doctor.fullName, initials: doctor.initials })),
            defaultCanSort: !!onSortChange,
            disableSortBy: !onSortChange,
        },
        {
            Header: t("appendix"),
            accessor: "documentCount",
            width: "10%",
            Cell: ({ value: documentCount }) => (_jsx(EvaluationStatuses, { type: "document", count: documentCount })),
            disableSortBy: true,
        },
    ], [onSortChange, t]);
    const handlePress = ({ id }) => {
        navigate("opinion", { opinionId: id });
    };
    return isSmallScreen ? (_jsx(FlatList, { minWidth: "full", overflow: "hidden", showsVerticalScrollIndicator: false, data: evaluations, renderItem: ({ item }) => _jsx(EvaluationListItem, { evaluation: item }), keyExtractor: ({ id }) => id, onEndReached: onEndReached })) : (_jsx(ReactTable, { columns: columns, data: evaluations, onSortChange: onSortChange, onEndReached: onEndReached, onPress: handlePress }));
};
export default HealthEvaluationTable;
